import classNames from 'classnames';
import React, { useId, useState } from 'react';
import { Tooltip } from 'reactstrap';

import './BetaTagTooltip.scss';

interface Props {
	placement: 'top' | 'bottom' | 'left' | 'right';
	betaTagClassName?: string;
	betaTagTextClassName?: string;
	tooltipClassName?: string;
}

export const BetaTagTooltip = (props: Props) => {
	const {
		placement = 'right',
		betaTagClassName,
		betaTagTextClassName,
		tooltipClassName,
	} = props;

	const randomId = useId();
	const barryToolTipId = randomId.replace(/:/g, '') + '-barry';

	const [tooltipOpen, setTooltipOpen] = useState(false);
	const toggle = () => setTooltipOpen(!tooltipOpen);

	return (
		<>
			<div className={classNames('beta-tag', betaTagClassName)} id={barryToolTipId}>
				<span className={classNames('beta-tag-text', betaTagTextClassName)}>
					BETA
				</span>
			</div>
			<Tooltip
				target={barryToolTipId}
				placement={placement}
				className={classNames('my-custom-tooltip', tooltipClassName)}
				toggle={toggle}
				isOpen={tooltipOpen}
				fade={false}
				modifiers={[{ name: 'offset', options: { offset: [0, 4] } }] as never}
			>
				This feature is experimental and may evolve based on feedback.
			</Tooltip>
		</>
	);
};
